import { axiosInstance } from 'boot/axios.js'

export async function brands(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'motorcycles/brands?sort=name&limit=100',
      params: {
        ...{},
        ...{
          'filters[where][status][eq]': 'ACTIVE'
        },
        ...queryParams
      },
      method: 'GET'
    })
    ctx.commit('brands', response.data.items)
  } catch (e) {
    throw e
  }
}

export async function get(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: '/motorcycles',
      params: {
        ...{},
        ...{
          'filters[where][status][eq]': 'ACTIVE'
        },
        ...queryParams
      },
      method: 'GET'
    })
    ctx.commit('item', response.data.items[0])
  } catch (e) {
    throw e
  }
}

export async function models(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: parseUrl('models', queryParams),
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('models', response.data.items)
  } catch (e) {
    throw e
  }
}

export async function years(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: parseUrl('years', queryParams),
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('years', response.data.items)
  } catch (e) {
    throw e
  }
}

export async function version(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: parseUrl('versions', queryParams),
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('version', response.data.items)
  } catch (e) {
    throw e
  }
}

function parseUrl(state, params) {
  if (state && params.id) {
    return 'motorcycles/' + state + '/' + params.id
  }
  return 'motorcycles/' + state
}
